/**
 * Formats a numeric value as a Euro currency string,
 * with two decimal places and a comma for thousands.
 * Example output: "1,234.56 €"
 *
 * @param {number} value - The numeric value to be formatted.
 * @returns {string} - The formatted currency string.
 */

export function formatEuro(value) {
  let numericValue = Number(value);
  if (isNaN(numericValue) || !isFinite(numericValue)) {
    return "[ERR]";
  }
  return numericValue.toLocaleString("de-DE", {
    style: "currency",
    currency: "EUR",
  });
}
